<template>
  <div class="container" :data-corp-id="corpId">
   <div class="shopDetailImg">
     <a class="shopDet-img" href="javascript:void(0);"><img :src="goodsData.cover"/></a>
     <h2 class="detail-title">{{goodsData.title}}</h2>
     <div class="detailDesc">
       <h2 v-if="goodsData.goodsAttr==[]">商品信息</h2>
       <!-- <div class="detailDesc-msg">
         <span v-for="item in goodsData.goodsAttr" v-html="item"></span>
       </div> -->
       <div class="detail-tab" v-if="goodsData.goodsDesc">
         <ul class="detailTab">
           <li class="det-20" v-on:click="detail()"  v-bind:class="{'det-shop':isColor_1}">商品详情</li>
           <li class="det-20" v-on:click="services()"  v-bind:class="{'det-services':isColor_2||!goodsData.goodsDesc}">售后服务</li>
         </ul>
         <div id="js_goods_desc" class="js_goods_desc" :class="{'dis':istelShow}" v-html="goodsDesc">{{goodsDesc}}</div>
         <div class="tel-shop" v-if="istelShow && goodsData.aftersaleMobile!=''">
            <p class="telShop"><i class="tel-20"></i>客服电话</p>
            <span>{{goodsData.aftersaleMobile}}</span>
         </div>
       </div>
     </div>
    <div class="footer-btn">
      <router-link class="moreMsg" :to="{ path: '/welfare/preorder',query:{type: addressType,goodsId:goodsId,goodsVoucherId:goodsVoucherId,orderGoodsVoucherId:orderGoodsVoucherId,welfareType:welfareType,isReal:isReal,isVirtual:isVirtual,shippingType:shippingType,cover:cover,title:title,catname:catname,shippingNote:shippingNote,extensionVirtualCode:extensionVirtualCode} }" v-if="status == 3"><button class="imm-receive">立即领取</button></router-link>
      <button class="imm-receive disabled" v-if="status == 1">已领取</button>
      <button class="imm-receive disabled" v-if="status == 6">已过期</button>
      <button class="imm-receive disabled" v-if="status == 7">已下架</button>
      <button class="imm-receive disabled" v-if="status == 8">已领完</button>
    </div> 
    
   </div>
   <x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
        <div class="content-wrap">
           <p>{{msg}}</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="tipDialog=false">知道啦</a>
        </div>
      </x-dialog>
      <home :ishome=0></home>
  </div>
</template>
<script>
import aghm from '../../api/aghm.js'
import  XDialog  from 'vux/src/components/x-dialog/index.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
export default {
  data () {
    return {
      tipDialog:false,
      msg:'',

        goodsDesc: '',
      goodsData:{},
      status:0,
      addressType:0,
      istelShow:false,
      isColor_1:true,
      isColor_2:false,
      goodsId:'',
      goodsVoucherId:'',
      orderGoodsVoucherId:'',
      welfareType:'',
      isReal:'',
      isVirtual:'',
      shippingNote:'',
      shippingType:'',
      cover:'',
      title:'',
      catname:'',
      extensionVirtualCode:'',
    }
  },
  components:{
    XDialog,
    home
  },
  computed:{
  	 ...mapGetters({
      getUserInfo: 'getUserInfo',
    }),
    corpId(){
      return this.getUserInfo.corpId || '';
    },

  },
  watch:{

  },
  beforeDestroy() {
    // 组件销毁时恢复默认标题
    this.$store.commit('CORP_CUSTOMIZE_ATTR', {
      data: {
        key: 'page_title_default',
        value: ''
      }
    })
  },
  created(){
   
      let gid = this.$route.query.goodsId;
      let vid = this.$route.query.goodsVoucherId;
      let oid = this.$route.query.orderGoodsVoucherId;
      let type = this.$route.query.welfareType;
      aghm.getGoodsInfo({
          goodsId:gid,
          goodsVoucherId:vid,
          orderGoodsVoucherId:oid,
          welfareType:type
        }).then((res) =>{
          if(res){
              let data = res.data.body;
              // document.getElementById('js_goods_desc').innerHTML = data.goodsDesc;
              this.goodsDesc = data.goodsDesc;
              // this.istelShow = this.goodsDesc ? false : true;

              let _shippingType = data.shippingType;
              let _welfareType = data.welfareType;
              let _isReal = data.isReal;
              let _isVirtual = data.isVirtual;

              this.goodsData = data;
              this.status = data.status;

              this.goodsId = gid
              this.goodsVoucherId=vid
              this.orderGoodsVoucherId=oid
              this.welfareType=type
              this.isReal=_isReal
              this.isVirtual=_isVirtual
              this.shippingType=_shippingType;
              this.cover=data.cover
              this.title=data.title
              this.catname=data.catName
              this.shippingNote = data.shippingNote
                this.extensionVirtualCode = data.extensionVirtualCode||''

              if(_welfareType ==1){
                  if(_shippingType==1){
                      this.addressType = 1;
                  }else{
                      this.addressType = 2;
                  }
              }else{
                  if(_isReal==1){
                      this.addressType = 1;
                  }
                  if(_isVirtual==1){
                      this.addressType = 3;
                  }
              }
          }else{
              this.tipDialog = true;
              this.msg = '数据错误';
          }


      },(error) =>{
          this.tipDialog = true;
          this.msg = error;
      })
  },
  methods:{
    detail:function () {
      this.istelShow = false;
      this.isColor_1 = true;
      this.isColor_2 = false;
    },
    services:function(){
      this.istelShow = true;
      this.isColor_1 = false;
      this.isColor_2 = true;
    }
  },
  mounted(){
    document.body.className = 'routeReady bgfff';
    this.$store.commit('CORP_CUSTOMIZE_ATTR', { 
        data: { 
          key: 'page_title_default', 
          value: '商品详情',
        } 
    })
  }
}
</script>